import { motion } from 'framer-motion'
import {
  FaDoorClosed,
  FaBuilding,
  FaChair,
  FaPalette,
  FaTools,
  FaCogs,
} from 'react-icons/fa'

const services = [
  {
    icon: FaDoorClosed,
    title: 'Portões e Grades',
    description:
      'Design e fabricação de portões, grades e cercas metálicas sob medida para residências e empresas.',
  },
  {
    icon: FaBuilding,
    title: 'Estruturas Metálicas',
    description:
      'Projetamos e construímos mezaninos, coberturas, galpões e outras estruturas metálicas robustas.',
  },
  {
    icon: FaChair,
    title: 'Móveis Estilo Industrial',
    description:
      'Criação de móveis únicos com design industrial, como mesas, estantes, e bancadas.',
  },
  {
    icon: FaPalette,
    title: 'Serralheria Artística',
    description:
      'Peças decorativas e funcionais em metal, com design exclusivo e acabamento impecável.',
  },
  {
    icon: FaTools,
    title: 'Manutenção e Reparos',
    description:
      'Serviços de manutenção preventiva e corretiva em estruturas metálicas e portões.',
  },
  {
    icon: FaCogs,
    title: 'Projetos Especiais',
    description:
      'Desenvolvemos soluções personalizadas em metal para atender às necessidades específicas do seu projeto.',
  },
]

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
}

export default function Services() {
  return (
    <section id="services" className="bg-gray-50 py-16 dark:bg-dark-primary brand:bg-brand-primary">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-center text-3xl font-bold text-light-primary dark:text-dark-primary brand:text-brand-primary md:text-4xl">
            Nossos Serviços
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-light-secondary dark:text-dark-secondary brand:text-brand-secondary">
            Oferecemos uma ampla gama de serviços em serralheria e estruturas metálicas,
            sempre com qualidade e precisão.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3"
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="h-full rounded-lg bg-white p-6 shadow-md transition-all hover:shadow-lg dark:bg-dark-secondary dark:shadow-none dark:hover:bg-dark-secondary/80 brand:bg-brand-secondary brand:shadow-none brand:hover:bg-brand-secondary/90"
            >
              <div className="mb-4 inline-block rounded-lg bg-orange-100 p-3 text-orange-600 dark:bg-blue-900/30 dark:text-blue-300 brand:bg-orange-800/20 brand:text-orange-400">
                <service.icon className="h-6 w-6" />
              </div>
              <h3 className="mb-3 text-xl font-semibold text-primary-800 dark:text-dark-primary brand:text-brand-light">
                {service.title}
              </h3>
              <p className="text-primary-600 dark:text-dark-secondary brand:text-brand-secondary">
                {service.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
} 